import { Dialog, DialogContent, DialogTrigger } from '../ui/dialog'

export const GiftDemoModal = ({ trigger }: { trigger: React.ReactNode }) => {
	return (
		<>
			<Dialog>
				<DialogTrigger asChild>{trigger}</DialogTrigger>
				<DialogContent className="w-full p-1 pt-12 sm:p-10">
					<div
						style={{
							position: 'relative',
							paddingBottom: 'calc(59.48605795516676% + 41px)',
							height: 0,
							width: '100%',
						}}
					>
						<iframe
							src="https://demo.arcade.software/eWX2Jt0v8gx7ItDG7s51?embed&show_copy_link=true"
							title="Gift a Plot"
							loading="lazy"
							allowFullScreen
							allow="clipboard-write"
							style={{
								position: 'absolute',
								top: 0,
								left: 0,
								width: '100%',
								height: '100%',
								colorScheme: 'light',
							}}
						></iframe>
					</div>
				</DialogContent>
			</Dialog>
		</>
	)
}
